export default class Passthrough {
	constructor (response) {
		this.url = response.url;
	}

	destroy () {
	}
}